import React, { useLayoutEffect } from 'react';
import styled, { css } from 'styled-components';
import { mediaMixin, token, Flex } from '@zillow/constellation';
export var StyleWrapper = styled.div.withConfig({
  displayName: "ResponsiveLightbox__StyleWrapper",
  componentId: "sc-1xi9m94-0"
})(["margin:0 auto;background-color:", ";box-shadow:0 0 5px rgba(0,0,0,0.35);position:relative;width:700px;max-width:100vw;max-height:", ";overflow-y:auto;", ";"], token('colors.gray200'), function (_ref) {
  var isLightboxBackgroundLocked = _ref.isLightboxBackgroundLocked;
  return isLightboxBackgroundLocked ? 'calc(100vh - 140px)' : 'inherit';
}, mediaMixin('md_lte', function (_ref2) {
  var isLightboxBackgroundLocked = _ref2.isLightboxBackgroundLocked;
  return css(["max-height:calc(100vh - 61px);max-height:", ";width:700px;box-shadow:none;margin-top:0;"], isLightboxBackgroundLocked ? 'calc(100vh - 61px);' : 'inherit');
}));
var CenterWrapper = styled(Flex).withConfig({
  displayName: "ResponsiveLightbox__CenterWrapper",
  componentId: "sc-1xi9m94-1"
})(["position:", ";left:0;right:0;top:", ";z-index:", ";margin:0;", ""], function (_ref3) {
  var isLightboxBackgroundLocked = _ref3.isLightboxBackgroundLocked,
      isCMS = _ref3.isCMS;
  return isLightboxBackgroundLocked || isCMS ? 'fixed' : 'absolute';
}, function (_ref4) {
  var isCMS = _ref4.isCMS;
  return isCMS ? '80px' : '140px';
}, token('zIndices.modal'), mediaMixin('md_lte', css(["top:61px;"])));

var ResponsiveLightbox = function ResponsiveLightbox(_ref5) {
  var _ref5$children = _ref5.children,
      children = _ref5$children === void 0 ? null : _ref5$children,
      className = _ref5.className,
      _ref5$isOpen = _ref5.isOpen,
      isOpen = _ref5$isOpen === void 0 ? true : _ref5$isOpen,
      isLightboxBackgroundLocked = _ref5.isLightboxBackgroundLocked,
      _ref5$isCMS = _ref5.isCMS,
      isCMS = _ref5$isCMS === void 0 ? true : _ref5$isCMS;
  useLayoutEffect(function () {
    if (!isLightboxBackgroundLocked) {
      window.scrollTo(0, 0);
    }
  }, [isLightboxBackgroundLocked]);
  return isOpen ? /*#__PURE__*/React.createElement(CenterWrapper, {
    isLightboxBackgroundLocked: isLightboxBackgroundLocked,
    isCMS: isCMS,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(StyleWrapper, {
    isLightboxBackgroundLocked: isLightboxBackgroundLocked,
    isCMS: isCMS,
    className: className
  }, children)) : null;
};

export default ResponsiveLightbox;
//# sourceMappingURL=ResponsiveLightbox.js.map